import {Text} from '@rdcomponents/text/text';
import {Flex} from 'antd';

import {spacer_m} from '../../../../css/var-export.scss';
import {AdditionalInfo} from '../../../../layout/additional-info/additional-info';
import {PageCard} from '../../../../layout/page-card/page-card';
import {Locale} from '../../../../provider/locale/locale';
import {ComplaintsCountType} from '../../../../service/reviews-and-answers-statistics/complaints-count/complaints-count-type';
import {CompareModeDelta} from '../compare-mode-delta/compare-mode-delta';

import * as styles from './auto-abuses-count.scss';

type PropsType = {
    isLoading?: boolean;
    autoAbusesCount: ComplaintsCountType | null;
    isCompareMode?: boolean;
    isPdf?: boolean;
};

export function AutoAbusesCount(props: PropsType): JSX.Element {
    const {isLoading, autoAbusesCount, isCompareMode, isPdf} = props;

    if (isLoading) {
        return <PageCard title={<Locale stringKey="REVIEW_AND_ANSWER_STATISTICS__AUTO_COMPLAINTS__TITLE" />} />;
    }

    return (
        <PageCard
            title={
                <Flex className={styles.AutoAbusesCount_header} justify="space-between">
                    <Text block bolder large stringKey="REVIEW_AND_ANSWER_STATISTICS__AUTO_COMPLAINTS__TITLE" />
                    {!isPdf && (
                        <AdditionalInfo>
                            <Flex gap={spacer_m} vertical>
                                <Text block bolder stringKey="REVIEW_AND_ANSWER_STATISTICS__AUTO_COMPLAINTS__TITLE" />
                                <Text block stringKey="REVIEW_AND_ANSWER_STATISTICS__AUTO_COMPLAINTS__TOOLTIP_TITLE" />
                            </Flex>
                        </AdditionalInfo>
                    )}
                </Flex>
            }
        >
            {isCompareMode ? (
                <CompareModeDelta
                    compareValue={autoAbusesCount?.comparedValue || 0}
                    delta={autoAbusesCount?.delta || 0}
                    value={autoAbusesCount?.value || 0}
                />
            ) : (
                <Text block bolder className={styles.AutoAbusesCount_mainPeriodValue}>
                    {autoAbusesCount?.value}
                </Text>
            )}
        </PageCard>
    );
}
